import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_WORKLOADS_ACCESS_CONTEXT_QUERY_KEY = 'woop-workloads-access-context';

type UseWorkloadsAccessContextQueryArgs = {
  clusterId: string;
  enabled?: boolean;
};

const getWorkloadsAccessContextQueryKey = (clusterId?: string) =>
  [WOOP_WORKLOADS_ACCESS_CONTEXT_QUERY_KEY, clusterId] as const;

const getWorkloadsAccessContextQueryOptions = ({
  clusterId,
  enabled = true,
}: UseWorkloadsAccessContextQueryArgs) =>
  queryOptions({
    queryKey: getWorkloadsAccessContextQueryKey(clusterId),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getWorkloadsAccessContext({
          clusterId,
        });
      return data;
    },
    enabled: makeIsEnabled(enabled, !!clusterId),
  });

export const useWorkloadsAccessContextQuery = ({
  clusterId,
  enabled = true,
}: UseWorkloadsAccessContextQueryArgs) => {
  const { isLoading, data, error, refetch } = useQuery(
    getWorkloadsAccessContextQueryOptions({ clusterId, enabled })
  );

  return {
    isLoading,
    data,
    error,
    refetch,
  };
};
